import { useEffect, useState } from 'react';

/**
 * Simple hook to check if component is mounted. For example to ensure running
 * client-only code on the client not on the server.
 * @author filipditrich <ditrich@nfctron.com>
 * @return {any}
 */
export const useIsMounted = () => {
	const [mounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
		return () => setMounted(false);
	}, []);

	return mounted;
};
